{"id":"Modal.FixedTopPanel","prefabs":{"default":{"children":[{"component":"Modal.FixedTopPanel","options":"options:*"}]}}}